import { loadStripe } from "@stripe/stripe-js";

// One Stripe instance per publishable key, created on first use.
//
// Two reasons this exists rather than calling loadStripe() where it's needed:
//
//   1. loadStripe() is not free and not idempotent — each call injects a
//      <script> for js.stripe.com and returns a NEW promise. Called in a
//      component body (which is where every one of our call sites had it), that
//      happens on every single render.
//
//   2. It REJECTS when the script can't load, which an ad blocker or privacy
//      extension does routinely, and offline always does. Combined with (1),
//      one blocked script became a wall of unhandled "Failed to load Stripe.js"
//      rejections — one per render — which is what buried the profile screen
//      after signing back in.
//
// So: cached per key, and the rejection is handled here. Consumers get `null`,
// and <Elements stripe={null}> renders nothing until a real instance arrives —
// the same state it shows while loading, so no caller needs to change.
const instances = new Map();

export const getStripe = (publishableKey) => {
  if (!publishableKey) return null;

  if (!instances.has(publishableKey)) {
    instances.set(
      publishableKey,
      loadStripe(publishableKey).catch((error) => {
        // Payment UI stays unavailable, but the app keeps working.
        console.error(
          "Stripe.js could not be loaded — it is most likely blocked by an extension:",
          error
        );
        return null;
      })
    );
  }

  return instances.get(publishableKey);
};

export default getStripe;
